/* GrowJoy Kids — Build a Plant (interactive lesson, ages 5–9, guide: Jadi)
   Mounts into: <div data-kids-app="build-a-plant" data-mascot="…jadi.jpg" data-badges='{"plant-hero":"…png",…}'></div>
   Needs: kids-shared.css, kids-badges.js. No other dependencies, no network calls.
   Learning: the four main parts of a flowering plant, where each is, and what job it does. */
(function () {
  "use strict";

  /* ---------- content (horticultural review pending — see CONTENT-REVIEW.md) ---------- */
  var PARTS = {
    roots: {
      name: "Roots",
      where: "Roots live underground, in the soil.",
      job: "Roots hold the plant tight in the ground and drink up water and minerals from the soil.",
      fun: "Roots grow toward water. Watering deeply helps roots grow long and strong.",
      icon: '<path d="M20 6v12M20 18c-6 4-9 10-10 16M20 18c6 4 9 10 10 16M20 22c-2 5-2 10-1 14M20 22c3 5 4 9 3 13" stroke="#b07a45" stroke-width="3" fill="none" stroke-linecap="round"/>'
    },
    stem: {
      name: "Stem",
      where: "The stem goes up the middle, from the soil to the top.",
      job: "The stem holds the plant up tall. Tiny tubes inside carry water up from the roots to the leaves, like a drinking straw.",
      fun: "Food made in the leaves travels through the stem to feed the rest of the plant.",
      icon: '<path d="M20 36V6" stroke="#2a6f33" stroke-width="5" stroke-linecap="round"/>'
    },
    leaves: {
      name: "Leaves",
      where: "Leaves grow out from the sides of the stem.",
      job: "Leaves catch sunlight. They use light, air and water to make sugar, the plant's food.",
      fun: "This is called photosynthesis. While they do it, leaves give out oxygen, the air we breathe!",
      icon: '<path d="M20 20C12 8 4 12 4 20c6 4 12 4 16 0zM20 20c8-12 16-8 16 0-6 4-12 4-16 0z" fill="#3e9a49"/>'
    },
    flower: {
      name: "Flower",
      where: "The flower sits at the top of the stem.",
      job: "Bright flowers invite bees and butterflies. They carry pollen between flowers so the plant can make seeds.",
      fun: "After the flower fades, fruits and seeds grow. Each seed can become a new plant!",
      icon: '<g transform="translate(20 20)"><ellipse cx="0" cy="-9" rx="6" ry="9" fill="#f07aa6"/><ellipse cx="0" cy="-9" rx="6" ry="9" fill="#f07aa6" transform="rotate(72)"/><ellipse cx="0" cy="-9" rx="6" ry="9" fill="#f07aa6" transform="rotate(144)"/><ellipse cx="0" cy="-9" rx="6" ry="9" fill="#f07aa6" transform="rotate(216)"/><ellipse cx="0" cy="-9" rx="6" ry="9" fill="#f07aa6" transform="rotate(288)"/><circle r="5" fill="#f6b81f"/></g>'
    }
  };
  var ORDER = ["roots", "stem", "leaves", "flower"];
  var QUIZ = [
    { q: "Which part drinks water from the soil?", a: "roots" },
    { q: "Which part makes food from sunlight?", a: "leaves" },
    { q: "Which part carries water up, like a straw?", a: "stem" },
    { q: "Which part helps the plant make new seeds?", a: "flower" }
  ];

  function mount(root) {
    var mascot = root.getAttribute("data-mascot") || "";
    var mascotReaction = root.getAttribute("data-mascot-reaction") || mascot;
    var badges = {}; try { badges = JSON.parse(root.getAttribute("data-badges") || "{}"); } catch (e) {}
    var placed = {}, nPlaced = 0, sel = null, drag = null, justDragged = false, mode = "intro", qi = 0, right = 0, waiting = false;

    root.classList.add("gj");
    root.innerHTML =
      '<div class="gj-game">' +
        '<div class="gj-main">' +
          '<div class="gj-titlebar"><div><h1>Build a Plant</h1><p class="gj-sub">Put each part where it belongs and see what it does.</p></div><span class="gj-chip" data-r="count">0 of 4 parts</span></div>' +
          '<div class="gj-stage bp-stage" data-r="stage" tabindex="0" aria-label="Plant picture">' + scene() + '<div class="gj-overlay" data-r="ov"></div></div>' +
          '<div class="bp-tray" data-r="tray" role="group" aria-label="Plant parts">' + ORDER.map(function (k) {
            return '<button type="button" class="bp-chip" data-k="' + k + '" aria-pressed="false"><svg viewBox="0 0 40 40" aria-hidden="true">' + PARTS[k].icon + "</svg>" + PARTS[k].name + "</button>";
          }).join("") + "</div>" +
          '<div class="gj-guide" data-r="guide" aria-live="polite"><img src="' + mascot + '" alt="Jadi the sprout"><div class="bp-card-body" data-r="tip"></div></div>' +
        "</div>" +
        '<aside class="gj-side">' +
          '<div class="gj-card"><h3>How to play</h3><ul class="gj-howto">' +
            '<li><b class="k">Drag</b>Drag a part onto the plant.</li>' +
            '<li><b class="k">Tap</b>Or tap a part, then tap where it goes.</li>' +
            '<li><b class="k">Learn</b>Watch what each part does.</li>' +
            '<li><b class="k">Quiz</b>Answer 4 quick questions to win your badge.</li></ul>' +
            '<p class="gj-keys">Keyboard: Tab to a part and press Enter. Then press 1 for roots, 2 for stem, 3 for leaves or 4 for flower.</p></div>' +
          '<div class="gj-card"><h3>Your badges</h3><div class="gj-shelf" data-r="shelf" style="margin-top:8px"></div></div>' +
        "</aside>" +
      "</div>";

    var $ = function (k) { return root.querySelector('[data-r="' + k + '"]'); };
    var stage = $("stage"), svg = stage.querySelector("svg");
    var chips = root.querySelectorAll(".bp-chip");

    function shelf() { window.GrowJoyUI.shelf($("shelf"), function (id) { return badges[id] || ""; }); }
    function say(title, body, fun, mood, extra) {
      $("tip").innerHTML = "<b>" + title + "</b><p>" + body + "</p>" + (fun ? '<p class="fun"><b>Fun fact:</b> ' + fun + "</p>" : "") + (extra || "");
      $("guide").className = "gj-guide" + (mood ? " " + mood : "");
      $("guide").querySelector("img").src = mood === "good" ? mascotReaction : mascot;
    }
    function count() { $("count").textContent = mode === "quiz" ? "Quiz " + (qi + 1) + " of 4" : nPlaced + " of 4 parts"; }
    function showPrompt() {
      if (!window.matchMedia("(max-width: 740px)").matches) return;
      if (root.classList.contains("bp-quiz")) root.querySelector(".gj-titlebar").scrollIntoView({ block: "start" });
      else $("guide").scrollIntoView({ block: "nearest" });
    }

    /* ---------- placing ---------- */
    function zoneAt(cx, cy) {
      var m = svg.getScreenCTM(); if (!m) return null;
      var p = svg.createSVGPoint(); p.x = cx; p.y = cy; var s = p.matrixTransform(m.inverse());
      if (s.x < 0 || s.x > 400 || s.y < 0 || s.y > 440) return null;
      if (s.y >= 300) return "roots";
      if (s.y < 130) return "flower";
      if (s.x > 168 && s.x < 232) return "stem";
      return "leaves";
    }
    function select(k) {
      sel = k;
      chips.forEach(function (c) { var on = c.getAttribute("data-k") === k; c.classList.toggle("sel", on); c.setAttribute("aria-pressed", on ? "true" : "false"); });
      stage.classList.toggle("show-zones", !!k);
    }
    function place(k, z) {
      if (!k || !z || mode !== "build") return;
      if (z !== k) {
        say("Not quite!", "That spot is for the " + PARTS[z].name.toLowerCase() + ". " + PARTS[k].where, null, "oops");
        stage.classList.remove("bp-wiggle"); void stage.offsetWidth; stage.classList.add("bp-wiggle");
        return;
      }
      placed[k] = true; nPlaced++; select(null);
      root.querySelector('.bp-chip[data-k="' + k + '"]').classList.add("used");
      root.querySelector('.bp-chip[data-k="' + k + '"]').disabled = true;
      svg.querySelector('[data-part="' + k + '"]').classList.remove("hidden");
      svg.querySelectorAll('[data-flow="' + k + '"]').forEach(function (f) { f.classList.add("on"); });
      count();
      if (nPlaced < 4) say(PARTS[k].name + ": great job!", PARTS[k].job, PARTS[k].fun, "good");
      else {
        say("You built a whole plant!", PARTS[k].job + " Now let's see what you remember.", PARTS[k].fun, "good",
          '<div class="gj-actions" style="justify-content:center;margin-top:10px"><button type="button" class="gj-btn" data-r="quizgo">Next Level</button></div>');
        $("quizgo").addEventListener("click", startQuiz);
        $("quizgo").focus({ preventScroll: true });
        showPrompt();
      }
    }

    /* drag (pointer) + tap-to-select */
    chips.forEach(function (ch) {
      ch.addEventListener("pointerdown", function (ev) {
        var k = ch.getAttribute("data-k"); if (placed[k] || mode !== "build") return;
        drag = { k: k, x0: ev.clientX, y0: ev.clientY, moved: false, ghost: null, id: ev.pointerId };
        ch.setPointerCapture(ev.pointerId);
      });
      ch.addEventListener("pointermove", function (ev) {
        if (!drag || drag.k !== ch.getAttribute("data-k")) return;
        if (!drag.moved && Math.hypot(ev.clientX - drag.x0, ev.clientY - drag.y0) > 8) {
          drag.moved = true; select(drag.k);
          drag.ghost = document.createElement("div"); drag.ghost.className = "bp-ghost";
          drag.ghost.innerHTML = '<svg viewBox="0 0 40 40">' + PARTS[drag.k].icon + "</svg>"; document.body.appendChild(drag.ghost);
        }
        if (drag.ghost) {
          drag.ghost.style.left = ev.clientX + "px"; drag.ghost.style.top = ev.clientY + "px";
          var z = zoneAt(ev.clientX, ev.clientY);
          svg.querySelectorAll(".bp-zone").forEach(function (el) { el.classList.toggle("hot", el.getAttribute("data-zone") === z); });
        }
      });
      function end(ev) {
        if (!drag || drag.k !== ch.getAttribute("data-k")) return;
        var d = drag; drag = null;
        if (d.ghost) { justDragged = true; setTimeout(function () { justDragged = false; }, 300); d.ghost.remove(); var z = zoneAt(ev.clientX, ev.clientY); if (z) place(d.k, z); else select(null); }
      }
      ch.addEventListener("pointerup", end);
      ch.addEventListener("pointercancel", function () { if (drag && drag.ghost) drag.ghost.remove(); drag = null; select(null); });
      /* click covers tap, mouse click and keyboard Enter/Space */
      ch.addEventListener("click", function () {
        var k = ch.getAttribute("data-k"); if (placed[k] || mode !== "build") return;
        if (justDragged) { justDragged = false; return; }
        select(sel === k ? null : k);
        if (sel) say(PARTS[k].name + " picked", "Now tap the place on the plant where it belongs.", null, null);
      });
    });
    stage.addEventListener("click", function (ev) {
      if (mode === "build" && sel) place(sel, zoneAt(ev.clientX, ev.clientY));
      else if (mode === "quiz" && !waiting) { var z = zoneAt(ev.clientX, ev.clientY); if (z) answer(z); }
    });
    root.addEventListener("keydown", function (ev) {
      if (ev.altKey || ev.ctrlKey || ev.metaKey || ev.repeat) return;
      var z = { "1": "roots", "2": "stem", "3": "leaves", "4": "flower" }[ev.key];
      if (!z) return;
      if (mode === "build" && sel) { ev.preventDefault(); place(sel, z); }
      else if (mode === "quiz" && !waiting) { ev.preventDefault(); answer(z); }
    });

    /* ---------- quiz ---------- */
    function startQuiz() { mode = "quiz"; qi = 0; right = 0; $("tray").hidden = true; root.classList.add("bp-quiz"); ask(); }
    function ask() { waiting = false; count(); say("Question " + (qi + 1) + " of 4", QUIZ[qi].q + " Tap it on the plant.", null, null); showPrompt(); }
    function answer(k) {
      var Q = QUIZ[qi], ok = k === Q.a; if (ok) right++;
      waiting = true;
      var last = qi === QUIZ.length - 1;
      say(ok ? "Correct!" : "That's the " + PARTS[k].name.toLowerCase() + ".",
        ok ? PARTS[Q.a].job : "The answer is the " + PARTS[Q.a].name.toLowerCase() + ". " + PARTS[Q.a].job, null, ok ? "good" : "oops",
        '<div class="gj-actions" style="justify-content:center;margin-top:10px"><button type="button" class="gj-btn" data-r="next">' + (last ? "See my stars" : "Next question") + "</button></div>");
      $("next").addEventListener("click", function () { if (last) finish(); else { qi++; ask(); } });
      $("next").focus({ preventScroll: true });
      showPrompt();
    }
    function finish() {
      mode = "done";
      var stars = right === 4 ? 3 : right >= 2 ? 2 : 1;
      window.GrowJoyUI.celebrate({
        stage: stage, overlay: $("ov"), badgeId: "plant-hero", badgeSrc: badges["plant-hero"] || "", stars: stars,
        title: right === 4 ? "You're a Plant Hero!" : "Well done, gardener!",
        text: "Great work! Try growing a real plant next.",
        againLabel: "Build again", again: reset
      });
      root.classList.remove("bp-quiz");
      stage.classList.add("bp-stage--done");
      var actions = $("ov").querySelector(".gj-actions");
      var replay = actions.querySelector("button");
      replay.classList.add("ghost");
      actions.setAttribute("aria-label", "What to do next");
      function nextProject(slug, label) {
        var locale = location.pathname.match(/^\/(ms|zh|zh-cn)(?=\/)/i);
        var link = document.createElement("a");
        link.className = "gj-btn bp-next-link";
        link.href = (locale ? locale[0] : "") + "/pages/kids-projects/" + slug;
        link.textContent = label;
        return link;
      }
      var bean = nextProject("bean-in-a-jar", "Try Bean in a Jar");
      var onions = nextProject("regrow-spring-onions-from-scraps", "Grow Spring Onions");
      onions.classList.add("ghost");
      actions.prepend(bean);
      actions.appendChild(onions);
      actions.appendChild(replay);
      bean.focus({ preventScroll: true });
      say("You did it!", "Roots drink, the stem carries, leaves make food, and flowers make seeds.", null, "good");
      shelf();
    }

    function reset() {
      placed = {}; nPlaced = 0; mode = "build"; waiting = false; select(null);
      root.classList.remove("bp-quiz"); stage.classList.remove("bp-stage--done");
      $("ov").hidden = true; $("tray").hidden = false;
      chips.forEach(function (c) { c.classList.remove("used"); c.disabled = false; });
      svg.querySelectorAll("[data-part]").forEach(function (p) { if (p.getAttribute("data-part") !== "sprout") p.classList.add("hidden"); });
      svg.querySelectorAll(".bp-flow").forEach(function (f) { f.classList.remove("on"); });
      count();
      say("Hi, I'm Jadi!", "My seed has sprouted. A plant needs four parts to live and grow. Drag each part from the row below onto me.", null, null);
    }

    shelf(); count();
    $("ov").innerHTML = '<img class="gj-mascot" src="' + mascot + '" alt=""><p>Help Jadi put a plant together.</p>' +
      '<div class="gj-actions"><button type="button" class="gj-btn">Start</button></div>';
    $("ov").querySelector("button").addEventListener("click", reset);
    say("Hi, I'm Jadi!", "Let's build a plant together.", null, null);
  }

  /* ---------- the garden scene (SVG, drawn in code; swap for illustrator art later) ---------- */
  function scene() {
    function leaf(x, y, r, s) { return '<path d="M0 0C14-20 46-20 56 0 46 16 14 18 0 0z" fill="#3e9a49" transform="translate(' + x + " " + y + ") rotate(" + r + ") scale(" + s + ')"/>'; }
    function drops(pts, dy, dur) { return pts.map(function (p, i) { return '<circle class="bp-anim-up" cx="' + p[0] + '" cy="' + p[1] + '" r="4.5" fill="#1e8fe1" style="--dy:' + dy + "px;animation-delay:" + (i * dur / pts.length).toFixed(2) + "s;animation-duration:" + dur + 's"/>'; }).join(""); }
    var petals = ""; for (var a = 0; a < 360; a += 60) petals += '<ellipse cx="0" cy="-22" rx="13" ry="21" fill="#f07aa6" transform="rotate(' + a + ')"/>';
    var rays = ""; [[290, 90], [270, 120], [300, 130]].forEach(function (p, i) { rays += '<path class="bp-anim-pulse" style="animation-delay:' + i * 0.4 + 's" d="M' + (p[0] + 30) + " " + (p[1] - 30) + "L" + p[0] + " " + p[1] + '" stroke="#f6b81f" stroke-width="4" stroke-linecap="round"/>'; });
    var pebbles = ""; [[30, 330], [90, 400], [150, 350], [260, 420], [330, 345], [370, 395], [60, 425], [210, 330]].forEach(function (p) { pebbles += '<circle cx="' + p[0] + '" cy="' + p[1] + '" r="4" fill="#6a4326"/>'; });
    return '<svg viewBox="0 0 400 440" role="img" aria-label="A sprouting seed in the soil, waiting for its parts">' +
      '<defs><linearGradient id="bp-sky" x1="0" x2="0" y1="0" y2="1"><stop offset="0" stop-color="#bfe3f5"/><stop offset="1" stop-color="#eaf7fc"/></linearGradient></defs>' +
      '<rect width="400" height="300" fill="url(#bp-sky)"/><circle cx="350" cy="52" r="26" fill="#f6b81f"/>' +
      '<g class="bp-flow" data-flow="leaves">' + rays + "</g>" +
      '<rect y="300" width="400" height="140" fill="#8a5a36"/>' + pebbles +
      '<rect class="bp-zone" data-zone="roots" x="110" y="306" width="180" height="120" rx="14"/>' +
      '<rect class="bp-zone" data-zone="stem" x="170" y="132" width="60" height="164" rx="14"/>' +
      '<rect class="bp-zone" data-zone="leaves" x="40" y="150" width="128" height="130" rx="14"/>' +
      '<rect class="bp-zone" data-zone="leaves" x="232" y="150" width="128" height="130" rx="14"/>' +
      '<rect class="bp-zone" data-zone="flower" x="140" y="20" width="120" height="108" rx="14"/>' +
      '<g data-part="sprout"><ellipse cx="200" cy="300" rx="14" ry="6" fill="#a8763f"/><path d="M200 300v-18" stroke="#3e9a49" stroke-width="4" stroke-linecap="round"/>' + leaf(200, 284, -150, 0.35) + leaf(200, 284, -30, 0.35) + "</g>" +
      '<g class="bp-part hidden" data-part="roots"><path d="M200 300v40M200 320c-20 10-40 30-50 60M200 320c20 10 40 30 50 60M200 340c-8 20-10 45-6 70M200 340c10 18 14 40 12 64M175 340c-14 4-26 12-34 22M226 342c14 4 26 12 32 24" stroke="#c4925c" stroke-width="5" fill="none" stroke-linecap="round"/></g>' +
      '<g class="bp-part hidden" data-part="stem"><path d="M200 300C194 240 206 180 200 120" stroke="#2a6f33" stroke-width="12" fill="none" stroke-linecap="round"/></g>' +
      '<g class="bp-part hidden" data-part="leaves">' + leaf(196, 262, -160, 1) + leaf(204, 238, -20, 1) + leaf(196, 206, -155, 0.95) + leaf(204, 178, -25, 0.9) + leaf(198, 150, -150, 0.75) + "</g>" +
      '<g class="bp-part hidden" data-part="flower"><g transform="translate(200 98)">' + petals + '<circle r="15" fill="#f6b81f"/></g></g>' +
      '<g class="bp-flow" data-flow="roots">' + drops([[150, 380], [250, 380], [196, 410]], -70, 1.8) + "</g>" +
      '<g class="bp-flow" data-flow="stem">' + drops([[200, 296], [200, 296], [200, 296]], -170, 2.1) + "</g>" +
      '<g class="bp-flow" data-flow="flower"><g class="bp-anim-bee"><g transform="translate(290 70)"><ellipse cx="0" cy="-8" rx="8" ry="5" fill="#e8f4ff" opacity=".9"/><ellipse rx="12" ry="8" fill="#f2c230"/><rect x="-4" y="-8" width="3" height="16" fill="#222"/><rect x="2" y="-8" width="3" height="16" fill="#222"/><circle cx="-11" cy="-1" r="5" fill="#222"/></g></g></g>' +
      "</svg>";
  }

  function init() { document.querySelectorAll('[data-kids-app="build-a-plant"]').forEach(mount); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
})();
